import { Tasks_Controller } from '@app/controllers/tasks-controller'

export class Project_Task {
    private readonly element: HTMLElement|null = null

    protected readonly title: string

    public constructor( selector: string ) {
        this.title = selector
        this.element = document.querySelector( `.project-task:has([data-spotlight="${selector}"] )` )

        this.init_actions()
    }

    private init_actions() {
        this.element?.addEventListener( 'click', () => this.init_spotlight() )
    }

    public complete() {
        if ( ! this.element ) {
            return
        }

        this.element.classList.add( 'completed' )
    }

    public reset() {
        if ( ! this.element ) {
            return
        }

        this.element.classList.remove( 'completed' )
    }

    public check() {

    }

    private init_spotlight() {
        const controller = Tasks_Controller.getInstance() as Tasks_Controller
        controller.init_spotlight( this.title )
    }
}

export class Project_Estimate_Task extends Project_Task {
    check() {
        const estimates = this.title.includes( 'offer' ) ? project.get_meta_value( 'project-planning-offer-estimates' ) : project.get_meta_value( 'project-planning-estimates' )
        let key: string|null = null

        switch ( this.title ) {
            case 'cutting-estimate':
            case 'offer-cutting-estimate':
                key = 'cutting'
                break
            case 'cnc-estimate':
            case 'offer-cnc-estimate':
                key = 'cnc'
                break
            case 'fitting-estimate':
            case 'offer-fitting-estimate':
                key = 'fitting'
                break
            case 'finishing-estimate':
            case 'offer-finishing-estimate':
                key = 'finishing'
                break
            case 'assembly-estimate':
            case 'offer-assembly-estimate':
                key = 'assembly'
                break
        }

        if ( ! key ) {
            return
        }

        if ( estimates[key] ) {
            this.complete()
        } else {
            this.reset()
        }
    }
}

export class Project_Planning_Task extends Project_Task {
    check() {
        const meta_value = project.get_meta_value( 'project-properties' )

        if ( this.title in meta_value ) {
            this.complete()
        } else {
            this.reset()
        }
    }
}

export class Project_Assembly_Date_Task extends Project_Task {
    check() {
        const meta_value = project.get_meta_value( 'project-assembly' )

        if ( meta_value.type ) {
            this.complete()
        } else {
            this.reset()
        }
    }
}
